import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Eleicao } from '../models/eleicao.model';
import { Integracao } from '../models/integracao.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IntegracaoService {
  configHeader: any;

  constructor(
    private http: HttpClient
    ) { }
    
  public listarPorIdEleicao(idEleicao: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get(`${environment.url_api}/integracoes/eleicao/${idEleicao}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error.message);
          }
        )
    })
  }
  public salvarIntegracaoEleicao(integracao: Integracao, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.post(`${environment.url_api}/integracoes`, integracao, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err);
          }
        )
    })
  }
  public editarIntegracaoEleicao(idIntegracao: number, integracao: Integracao, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.put(`${environment.url_api}/integracoes/${idIntegracao}`, integracao, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err);
          }
        )
    })
  }
  
}
